module.exports = __webpack_public_path__ + "static/media/moln.4b48a136.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shapes/moln.svg
// module id = 197
// module chunks = 0